import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
    AppBar, Toolbar, IconButton, Typography, Drawer, List, ListItemText,Collapse, ListItemButton, ListItem, CssBaseline, Divider, Box, useTheme,
    useMediaQuery, Badge, Grid, Stack, Tooltip, Avatar, Menu, MenuItem, ListItemIcon, Dialog, DialogActions, DialogTitle, DialogContentText, DialogContent,
    Button,Chip,
} from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import MenuOpen from '@mui/icons-material/MenuOpen';
import MenuIcon from "@mui/icons-material/Menu";
import InstagramIcon from "../assets/icons/mediaIcons/instagram.png";
import WhatsAppIcon from "../assets/icons/mediaIcons/whatsapp.png";
import facebookMessanger from "../assets/icons/mediaIcons/facebookMessanger.png";
import profile from "../assets/icons/mediaIcons/profile.png";
import google from "../assets/icons/mediaIcons/google.png";
import EditIcon from "@mui/icons-material/Edit"; // MUI edit icon
import { styled } from '@mui/material/styles';
import { Link, useNavigate, useLocation } from "react-router-dom";
import AuthUser from './Auth/AuthUser';
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import config from '../AppConfig';
import LogoEdit from '../Components/Cobrand/LogoEdit';
import Switching from '../assets/images/switch.png';
import { affiliateLogout } from "../redux/authSlice";
import { fetchData,postData } from "../redux/apiSlice";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Freez from '../Components/Loader/Loader';
import Backdrop from '@mui/material/Backdrop';
import Collapsible from '../assets/icons/sideBarIcons/Collapsible.png';
import CollapsibleOpen from '../assets/icons/sideBarIcons/CollapsibleOpen.png';

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}));
// const drawerWidth = 320;
let cobrandActiveFlag = 1;
// let logoFlag = 0;
function AppSidebar({drawerWidth,changedCollapsedValue,collapsed}) {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user, validateRoles } = AuthUser();
    const [mobileOpen, setMobileOpen] = useState(false);
    const company =JSON.parse(useSelector((state) => state.auth.company));
	const [companyLogoUrl,setCompanyLogoUrl] = useState();
	const [companylogo, setCompanyLogo] = useState();
    // const company = JSON.parse(localStorage.getItem('company'));
    // const [collapsed, setCollapsed] = useState(false);
    const [referralflag, setReferralFlag] = useState(company ? company.referral_flag : 0);
    const theme = useTheme();
    const isAuthenticated = localStorage.getItem('isAuthenticated')
    const [logoText, setLogoText] = useState();
    const appBarRef = useRef(null);
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openMenuToggle, setOpenMenuToggle] = useState(null);
    const SnapShotStatus = useSelector((state) => state.auth.SnapShotStatus);
    const [uploadLogo, setUploadLogo] = React.useState(false);
   const [freez, setFreez] = React.useState(false);
    const [referralTeams, setReferralTeams] = useState(company ? company.referral_terms_and_conditions : 0)
    let menuList = "";
    const taxFlag = useSelector((state) => state.auth.taxFlag);
    const [logoType, setLogoType] = useState();
    const [companyId, setCompanyId] = React.useState(user.roles_id == 3 || user.roles_id == 4 || user.roles_id == 5 ? user.company_master_id : '');
    const companyDetails = JSON.parse(localStorage.getItem('company'));
	const [logoFlag, setLogoFlag] = useState(0);
    const [companyData, setCompanyData] = useState([]);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const [selectedMenu, setSelectedMenu] = useState(1);
    const menuRefs = useRef([]);
    const [logoURL, setlogoURL] = useState('');
    const getSoftWareLogo = async () => {
        // setlogoURL(require("../assets/images/uploadLogo.png"));
        const apiUrl = '/softwarelogo';
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res && res.logo) {
            setlogoURL( res.logo);
            setLogoFlag(1);
        } else {
            // setlogoURL(require("../assets/images/uploadLogo.png"));
            setLogoFlag(0);
        }
    }
            
    useEffect(() => {
        if (user.roles_id === 7 || user.roles_id === 8) {
            getSoftWareLogo();
        }
    }, []);
   
    useEffect(() => {
        // Find the active menu or submenu based on location.pathname
        menuList.forEach((item, parentIndex) => {
            if (location.pathname === item.url) {
				setSelectedMenu({ parentIndex, childIndex: null });
				setOpenMenuToggle(parentIndex);
            } else if (item.submenu) {
            item.submenu.forEach((subItem, childIndex) => {
                if (location.pathname === subItem.url) {
					setSelectedMenu({ parentIndex, childIndex });
					setOpenMenuToggle(parentIndex);
                }
            });
            }
        });
        // Prevent re-triggering if already initialized
        // if (!hasInitialized && menuList?.length > 0) {
        //   const submenuIndex = menuList.findIndex((item) =>
        //     item.submenu?.some((sub) => sub.url === location.pathname)
        //   );
      
        //   if (submenuIndex !== -1) {
        //     setOpenMenuToggle(submenuIndex);
        //   } else {
        //     // Optionally check if it's a top-level active tab
        //     const directIndex = menuList.findIndex((item) => item.url === location.pathname);
        //     if (directIndex !== -1) {
        //       setOpenMenuToggle(null);
        //     }
        //   }
      
        //   setHasInitialized(true); 
        // }
      }, [location.pathname, menuList]);

      useEffect(() => {
        // Scroll the selected menu or submenu into view
        if (selectedMenu) {
          const { parentIndex, childIndex } = selectedMenu;
          const refIndex = childIndex !== null ? `${parentIndex}-${childIndex}` : parentIndex;
          const element = menuRefs.current[refIndex];
          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }
      }, [selectedMenu]);

        useEffect(() => {
                if (user.roles_id == 3 || user.roles_id == 4 || user.roles_id == 5) {
                    getCompanyLogoDetails();
                }
        }, [])

        const getCompanyLogoDetails = async () => {
                const apiUrl = '/getCompanyLogoDetails/' + companyId; // Replace with your API endpoint
                const res = await dispatch(fetchData(apiUrl)).unwrap();
                if (res) {
                    if(res.success === true) {
                        setCompanyData(res.data);
                        setLogoText(res.data.default_logo_text);
                        setCompanyLogoUrl(res.data.company_logo_url);
                        setLogoType(res.data.check_logo_type);
                    }
                }
        }

      const handleMenuClick = (parentIndex) => {
        setOpenMenuToggle(openMenuToggle === parentIndex ? null : parentIndex);
    };

    const handleLogoFlag = (flag) => {
        // logoFlag = flag;
		setLogoFlag(flag);
    }
    const openMenu = Boolean(anchorEl);
    const handleLogoURL = (image) => {
        setCompanyLogo(image);
        setlogoURL(image);

    }
    const handleCloseUploadLogo = (value) => {
        setUploadLogo(false);
    }
    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const navigate = useNavigate();
    const handleToggle = (index) => {
        setOpenMenuToggle(openMenuToggle === index ? null : index);
    };
   
    const handleClose = () => {
        setAnchorEl(null);
    };

    if (isAuthenticated == null) {
        // dispatch(logout());
        localStorage.clear();
        // console.log(isAuthenticated)
        navigate('/login');
    }
    const handleLogout = () => {
        // dispatch(logout());
        localStorage.clear();
        // console.log(isAuthenticated)
        navigate('/login');
    }
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    //loader function and variable end

    const handleAffiliateLogout = async () => {
        handleFreezStart();
        const apiUrl = '/login';
        const args = {
            email: admin.email,
            password: config.MasterPassword,
            masterPass: true,
        }
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        // console.log(res);
        if (res) {
            handleFreezStop();
            await dispatch(affiliateLogout(res));
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            localStorage.removeItem('company');
            localStorage.setItem('user', JSON.stringify(res.user));
            localStorage.setItem('token', res.token);
            localStorage.removeItem('switchedAccount');
            localStorage.removeItem('admin');
            localStorage.removeItem('SnapShotStatus');
            // localStorage.setItem('hasLoggedIn',true);
            // console.log(localStorage.getItem('user'))	
            navigate('/manageleads/hot-leads');
        }
        // validateRoles();
    }

    function AffiliateMenu()  {
        return (
                <Box sx={{ display: "flex", alignItems: "center", gap:2, justifyContent:"center",textAlign:"center" }}>
                    <Typography sx={{ fontSize: isMobile ? "0.7rem" : "1rem" }}>You Are Viewing As A <br />
                        <b> {companyDetails ? companyDetails.company_name : ""}</b> </Typography>
                    <Divider orientation="vertical" flexItem style={{ borderColor: "#000000", borderWidth: "2px" }} />
                    <Typography>User <br />
                        <b>{user ? user.name : ''}</b> </Typography>
                    <Divider orientation="vertical" flexItem style={{ borderColor: "#000000", borderWidth: "2px" }} />
                    <Typography>Role <br />
                        <b>Affiliate</b> </Typography>
                    <Button variant="contained" className="greenButton" onClick={(e) => { handleAffiliateLogout() }} startIcon={<img src={Switching} alt="Switch" />} >Switch</Button>
                </Box>
        )
                
    };

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={openMenu}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <div className={window.location.pathname === '/affiliate/initialcobrandsetup' ? 'drawerHide' : ''} >
                <MenuItem onClick={() => { navigate('/my-profile') }}>
                    <Avatar /> My Profile
                </MenuItem>
                <Divider />
            </div>
            <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                    <LogoutIcon fontSize="small" />
                </ListItemIcon>
                Logout
            </MenuItem>
        </Menu>
    );

    const menuItems = [
        // user.roles_id === 3 || user.roles_id === 4 || user.roles_id === 5 &&
        { id: 1, text: "Dashboard", url:"/affiliate/dashboard", icon: require("../assets/icons/sideBarIcons/Dashboard.png"), },
        { id: 2, text: "Dashboard", url: "/dashboard", icon: require("../assets/icons/sideBarIcons/Dashboard.png"), },
        { id: 3, text: "Performance Dashboard", url: "/performancedashboard", icon: require("../assets/icons/sideBarIcons/PerformanceDashboard.png"), },
        { id: 4, text: "Agent Dashboard", url: "/agentdashboard", icon: require("../assets/icons/sideBarIcons/AgentDashboard.png"), },
        { id: 5, text: "Retention Dashboard", url: "/retentiondashboard", icon: require("../assets/icons/sideBarIcons/RetentionDashboard.png"), },
        (user.roles_id === 3) &&
        { id: 6, text: "Commission Summary", url: '/affiliate/commission-summary-report', icon: require("../assets/icons/sideBarIcons/CommissionSummary.png"), },
        { id: 7, text: "Commission Summary", url: '/commission-summary', icon: require("../assets/icons/sideBarIcons/CommissionSummary.png"), },
        { id: 8, text: "Commission Payments", icon: require("../assets/icons/sideBarIcons/CommissionPayments.png"), url: '/commission-payments', },
        { id: 9, text: "Bonus Commission Target", icon: require("../assets/icons/sideBarIcons/BonusCommissiontarget.png"), url: '/commission-targets', },
        { id: 10, text: 'Commission Rates', icon: require("../assets/icons/sideBarIcons/Commissionrates.png"), url: '/commission-rates', },
        { id: 11, text: "Abandoned Members", icon: require("../assets/icons/sideBarIcons/AbandonedMembers.png"), url: '/AbandonedMembers', },
        { id: 12, text: "My Co-Brand Links", icon: require("../assets/icons/sideBarIcons/Cobrandlink.png"), url: '/affiliate/mylink' },
        { id: 13, text: 'Users', icon: require("../assets/icons/sideBarIcons/Users.png"), url: '/userpanel', },
        { id: 14, text: 'Company Details', icon: require("../assets/icons/sideBarIcons/CompanyDetails.png"), url: (user.roles_id == 1 || user.roles_id == 2) ? '/companypanel' : '/affiliate/companypanel/' + (company ? company.id : user ? user.company_master_id : ''), },
        // {id: 15, text: 'Company Details New',icon: require("../assets/icons/sideBarIcons/CompanyDetails.png"), url: '/companypanel1',  },
        { id: 16, text: (user.roles_id === 9) ? "Referred Affiliates" : "Referral Program", icon: require("../assets/icons/sideBarIcons/ReferralProgram.png"), url: '/affiliate/referralprogram/', },
        { id: 17, text: 'Suspended Members', icon: require("../assets/icons/sideBarIcons/Suspendedmembers.png"), url: (user.roles_id == 1 || user.roles_id == 2) ? '/suspendedMemberList' : '/affiliate/SuspendedAffiliate', },
        { id: 18, text: 'Bank Details', icon: require("../assets/icons/sideBarIcons/Bankdetails.png"), url: '/affiliate/bankdetails/' + (company ? company.id : user ? user.company_master_id : ''), },
        { id: 19, text: 'Cobrand Setup', icon: require("../assets/icons/sideBarIcons/ReferralProgram.png"), url: (user.roles_id == 1 || user.roles_id == 2) ? '/customizationReview/advancedCBReview' : '/AdvancedCobrandSetup', },
        { id: 20, text: 'Member List', icon: require("../assets/icons/sideBarIcons/MembersList.png"), url: '/memberlist/active', },
        { id: 21, text: SnapShotStatus == 2 ? 'Lead Generation' : 'Lead Generation', icon: require("../assets/icons/sideBarIcons/CreditSnapshot.png"), url: '/affiliate/creditsnapshot/', },
        { id: 22, text: "Snapshot Leads", icon: require("../assets/icons/sideBarIcons/CSSLeads.png"), url: '/affiliate/myleads/enrolled', },
        { id: 27, text: 'Software Commissions', icon: require("../assets/icons/sideBarIcons/Softwarecommission.png"), url: '/software-commission-summary', },
        { id: 28, text: 'Software Payments', icon: require("../assets/icons/sideBarIcons/Softwarepayments.png"), url: '/software-commission-payments', },
        { id: 23, text: (user.roles_id == 1 || user.roles_id == 2) ? 'Pending Close List' : 'Pending Close Members', icon: require("../assets/icons/sideBarIcons/PendingClose.png"), url: '/pendingclosepanel/pending', },
        { id: 24, text: 'Reports', icon: require("../assets/icons/sideBarIcons/Reports.png"), url: (user.roles_id === 1 || user.roles_id === 2) ? '/reportpanel' : '/affiliate/reportpanel', },
        { id: 25, text: 'Automations', icon: require("../assets/icons/sideBarIcons/Automation.png"), url: '/automations/api-user', },
        { id: 26, text: 'W-9 Details', icon: require("../assets/icons/sideBarIcons/W-9.png"), url: (user.roles_id === 1 || user.roles_id === 2) ? '/Tax1099' : '/Form1099', },
        { id: 29, text: 'Manage Leads', icon: require("../assets/icons/sideBarIcons/ManageLeads.png"), url: '/manageleads/hot-leads', },
        { id: 30, text: 'Basic Cobrands Setup', icon: require("../assets/icons/sideBarIcons/Co-brand.png"), url: '/cobrand/all', },
        { id: 31, text: 'Referrals', icon: require("../assets/icons/sideBarIcons/Referrals.png"), url: '/referralreports' },
        { id: 32, text: 'Company Performance', icon: require("../assets/icons/sideBarIcons/CompanyPerformance.png"), url: '/company-referral-reports', },
        { id: 33, text: 'Software Referrals', icon: require("../assets/icons/sideBarIcons/SoftwareReferrals.png"), url: '/SoftwareReferrals', },
        { id: 34, text: 'Snapshot Leads', icon: require("../assets/icons/sideBarIcons/CSSLeads.png"), url: '/leadreports/enrolled', },
        { id: 35, text: 'Contact Logs', icon: require("../assets/icons/sideBarIcons/Contactlogs.png"), url: '/contactlog', },
        { id: 36, text: 'Bounced Emails', icon: require("../assets/icons/sideBarIcons/Bouncedemails.png"), url: '/bounceemail/pending', },
        { id: 37, text: 'Manage Members', icon: require("../assets/icons/sideBarIcons/Managemembers.png"), url: '/manageMembers' },
        { id: 38, text: 'Contact Type Configuration', icon: require("../assets/icons/sideBarIcons/Contacttypeconfiguration.png"), url: '/contactTypeConfig' },
        { id: 39, text: 'CRC Lead Simulation', icon: require("../assets/icons/sideBarIcons/CRCLeadsimulation.png"), url: '/crc-leads', },
        { id: 40, text: 'Set Default PID', icon: require("../assets/icons/sideBarIcons/SetdefaultPID.png"), url: '/SetDefaultPid' },
        { id: 41, text: 'PID Pool', icon: require("../assets/icons/sideBarIcons/PIDPool.png"), url: '/PoolPid', },
        { id: 42, text: 'PID Manager', icon: require("../assets/icons/sideBarIcons/PIDManager.png"), url: '/PidManager', },
        { id: 43, text: 'Login Activities', icon: require("../assets/icons/sideBarIcons/LoginActivities.png"), url: '/login-activity', },
        { id: 44, text: 'Holidays', icon: require("../assets/icons/sideBarIcons/Holiday.png"), url: '/holidays', },
        { id: 45, text: 'Notification Logs', icon: require("../assets/icons/sideBarIcons/Notificationlog.png"), url: '', disabled: true },
        { id: 46, text: 'Click Reports', icon: require("../assets/icons/sideBarIcons/Clickreport.png"), url: '', disabled: true },
        { id: 47, text: 'Blog Dashboard', icon: require("../assets/icons/sideBarIcons/Blogdashboard.png"), url: '', disabled: true },
        {
            id: 48, text: 'Referral Program', icon: require("../assets/icons/sideBarIcons/ReferralProgram.png"),
            disabled: referralflag ? referralflag == 1 ? false : true : true,
            url: referralflag ? referralflag == 1 ? '/affiliate/referralprogram/' : ' ' : ' ',
        },
        {
            id: 49, text: 'CreditSnapShot', icon: require("../assets/icons/sideBarIcons/CreditSnapshot.png"), disabled: SnapShotStatus ? SnapShotStatus == 2 ? false : true : true,
            url: SnapShotStatus ? SnapShotStatus == 2 ? '/affiliate/creditsnapshot/' : ' ' : ' ',
        },
        { id: 50, text: 'Cobranding panel', icon: require("../assets/icons/sideBarIcons/Co-brand.png"), url: '/cobrandpanel', },
        { id: 51, text: 'Referral Program', icon: require("../assets/icons/sideBarIcons/ReferralProgram.png"), disabled: referralTeams ? referralTeams == 1 ? false : true : true, url: referralTeams ? referralTeams == 1 ? '/affiliate/referralprogram/' : ' ' : ' ', },
        { id: 52, text: 'Dashboard', icon: require("../assets/icons/sideBarIcons/Dashboard.png"), url: '/partner-admin/dashboard', },
        { id: 53, text: 'CRO Signup Link', icon: require("../assets/icons/sideBarIcons/CROSignupLink.png"), url: '/partner-admin/crolink', },
        { id: 54, text: 'Administration', icon: require("../assets/icons/sideBarIcons/Administration.png"), url: '/partner-admin/administration', },
        { id: 55, text: 'CRO Enrollments', icon: require("../assets/icons/sideBarIcons/CROEnrollments.png"), url: '/partner-admin/croenrollment', },
        { id: 56, text: 'CRO Leads', icon: require("../assets/icons/sideBarIcons/CROLeads.png"), url: '/partner-admin/croleads', },
        { id: 57, text: 'Accounts Set to Cancel', icon: require("../assets/icons/sideBarIcons/Accountssettocancel.png"), url: '/pendingclosepanel/pending', },
        { id: 58, text: 'Accounts With Failed Payment', icon: require("../assets/icons/sideBarIcons/ceithfailedpayment.png"), url: '/affiliate/SuspendedAffiliate', },
        { id: 59, text: 'My Profile', icon: require("../assets/icons/sideBarIcons/Dashboard.png"),url: '/my-profile', },
        { id: 60, text: 'Commission Summary', icon: require("../assets/icons/sideBarIcons/Softwarecommission.png"), url: '/software-commissions', },
        { id: 61, text: 'Bank Details', icon: require("../assets/icons/sideBarIcons/Bankdetails.png"), url: '/software/bankdetails/' + (user ? user.software_name : ''), },
        { id: 62, text: 'Events', icon: require("../assets/icons/sideBarIcons/Events.png"), url: '/events', },
        {
            id: 63, text: "Abandoned Members", 
            text: 'Abandoned Members',
            icon: require("../assets/icons/sideBarIcons/AbandonedMembers.png"), 
            url: '/affiliate/AbandonedMembers'
        },
        // {  text: "Action Required", icon: require("../assets/icons/sideBarIcons/ActionRequird.png") },
        // { text: "Lead Generation Enable", icon: require("../assets/icons/sideBarIcons/LeadGenEnable.png") },
        // { text: "Members Access", icon: require("../assets/icons/sideBarIcons/MemberAccess.png") },
        { id: 64, text: "Emails & Campaigns", icon: require("../assets/icons/sideBarIcons/Emailsandcampaign.png"),
            submenu:[
                { id: 65, text: "Recipient List", url: "/recipient-list", icon: require("../assets/icons/sideBarIcons/RecipientList.png"), },
                { id: 66, text: "Create Email Templates", url: "/email-editor", icon: require("../assets/icons/sideBarIcons/CreateEmail.png"), },
                { id: 67, text: "All Campaigns", url: "/campaigns", icon: require("../assets/icons/sideBarIcons/AllCampaign.png"), },
                { id: 68, text: "Events", url: "/event-list", icon: require("../assets/icons/sideBarIcons/Events.png"), },
            ]
        }
    
    ]

    const getMenuList = (roleIds) => {
        return menuItems
            .filter(item => roleIds.includes(item.id))
            .sort((a, b) => roleIds.indexOf(a.id) - roleIds.indexOf(b.id));
    };
    
    if (user.roles_id === 1) {
        menuList = getMenuList([2, 3, 4, 5, 11, 6, 7, 8, 9, 27, 28, 29, 14, 13, 30, 19, 31, 32, 33, 34, 24, 35, 36, 23, 17, 10, 37, 38, 39, 40, 41, 42, 26, 43, 44,64,65,66,67,68,45,46, 47]);
    } else if (user.roles_id === 2) {
        menuList = getMenuList([ 2, 4, 5, 11, 29, 14, 13, 30, 19, 33, 23, 17, 6, 10, 7, 8, 9, 27, 28, 35, 36, 37, 24, 31, 34, 39, 41, 26, 43]);
    } else if (user.roles_id === 3 && (cobrandActiveFlag == 0 || cobrandActiveFlag == null)) {
        if (taxFlag > 0) {
            menuList = getMenuList([1, 26, 12, 13, 14, 16,63, 17, 18, 20, 21, 22, 23, 6,  24, 25]);
        } else {
            menuList = getMenuList([1, 12, 13, 14, 16,63, 17, 18, 20, 21, 22, 23, 6, 24, 25]);
        }
    } else if (user.roles_id === 3 && taxFlag > 0) {
        menuList = getMenuList([1, 26, 12, 13, 14, 16,63, 17, 18, 19, 20, 21, 22, 23, 6, 24, 25]);
    } else if (user.roles_id === 3) {
        menuList = getMenuList([1, 12, 13, 14, 16,63, 17, 18, 19, 20, 21, 22, 23, 24, 25, 6]);
    } else if (user.roles_id === 4) {
        menuList = getMenuList([1, 12, 14, 48, 20, 21, 23, 22, 17, 24]);
    } else if (user.roles_id === 5) {
        menuList = getMenuList([1, 12, 14, 50, 51, 20, 21, 23, 22, 17, 24]);
    } else if (user.roles_id === 6) {
        menuList = getMenuList([29, 35]);
    } else if (user.roles_id === 7) {
        menuList = getMenuList([52, 53, 54, 55, 56, 57, 58]);
    } else if (user.roles_id === 8) {
        menuList = getMenuList([52, 53, 55, 56, 57, 58]);
    } else if (user.roles_id === 9) {
        menuList = getMenuList([59, 16, 60, 61, 25]);
    } else if (user.roles_id === 10) {
        menuList = getMenuList([59]);
    } else if (user.roles_id === 11) {
        menuList = getMenuList([59]);
    } else if (user.roles_id === 12) {
        menuList = getMenuList([41]);
    } else if (user.roles_id === 13) {
        menuList = getMenuList([41, 62, 13, 29, 30, 38, 35]);
    } else if (user.roles_id === 14) {
        menuList = getMenuList([59]);
    }

    const switchedAccount = localStorage.getItem('switchedAccount');
    const admin = JSON.parse(localStorage.getItem('admin'));
    // const companyDetails = JSON.parse(localStorage.getItem('company'));

    const drawerContent = (
       <>
         <Box sx={{ height:isMobile?"auto": "100vh", overflow: "hidden",  display: "flex", flexDirection: "column",}}>
            {user.roles_id === 3 || user.roles_id === 4 || user.roles_id === 5 || user.roles_id === 7 || user.roles_id === 8 ?
                <div style={{ padding: isMobile?"16% 0 5px":"5% 0", display:"flex",flexDirection:"column", alignItems:"center", position: "sticky", top: 0,zIndex: 1,backgroundColor: "#fff"}}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #2C1A95",
                            borderRadius: "12px",
                            padding: "10px 16px",
                            width: "270px",
                            position: "relative",
                        }}
                    >
                        {/* Logo and Text */}
                        <Box sx={{ display: "flex", alignItems: "center", }}>
                             {
                                (logoURL && (user.roles_id === 7 || user.roles_id === 8)) && logoFlag ? (
                                    <img
                                    className="navbarlogo"
                                    style={{ height: isMobile ? "100%" : "90px" }}
                                    // src={logoURL.startsWith("http") || logoURL.startsWith("/") ? logoURL : config.BACKEND_URL + "images/SoftwareChannelMasterLogo/" + logoURL}
                                    src={config.BACKEND_URL + "images/SoftwareChannelMasterLogo/" + logoURL}
                                    alt="dash_logo"
                                    />
                                ) :
                                
                                company && companyLogoUrl ?
                                        
                                        <img className="navbarlogo" style={{ height: isMobile ? "100%" : "90px", }} src={config.BACKEND_URL + "images/companyLogo/" + companyLogoUrl} alt="company_logo" />
                                 : (
                                    <img
                                    className="navbarlogo"
                                    style={{ height: isMobile ? "100%" : "90px" }}
                                    src={require("../assets/images/uploadLogo.png")}
                                    alt="upload_logo"
                                    />
                                )
                            }
                            {/* {
                                company
                                    ?
                                    companyLogoUrl
                                        ?
                                        <img className="navbarlogo" style={{ height: isMobile ? "100%" : "90px", }} src={config.BACKEND_URL + "images/companyLogo/" + companyLogoUrl} alt="company_logo" />
                                        :
                                        <img className="navbarlogo" style={{ height: isMobile ? "100%" : "90px" }} src={require("../assets/images/uploadLogo.png")} alt="upload_logo" />
                                    :
                                    <img className="navbarlogo" style={{ height: isMobile ? "100%" : "90px" }} src={require("../assets/images/uploadLogo.png")} alt="upload_logo2" />
                            } */}
                            {/* <img src={require('../assets/images/mainLogo.jpg')} alt="MY Free score now" width="200" height="auto" /> */}
                        </Box>
                        {user.roles_id === 3 ?
                            <>
                                {/* Edit Button */}
                                <IconButton
                                    onClick={(e) => { setUploadLogo(true) }}
                                    sx={{
                                        position: "absolute",
                                        right: "-12px",
                                        bottom: "-12px",
                                        backgroundColor: "white",
                                        border: "2px solid #2C1A95",
                                        borderRadius: "50%",
                                        color: "#2C1A95",
                                        "&:hover": { backgroundColor: "#f3f3ff" },
                                    }}
                                >
                                    {(company && company.company_logo_url) ?
                                        <EditIcon />
                                        : <CloudUploadOutlinedIcon />}
                                </IconButton>
                            </>
                            : null}
                    </Box>
                    {(company && company.company_name) ?
                        <Typography fontWeight="bold" textAlign="center" mt={1}>{company.company_name}</Typography>
                        :""
                    }
                  
                  </div>
                : ""}
                
            <Divider sx={{ backgroundColor: "#6CC641" }} />
            <Box sx={{ flex: 1, overflowY: "auto", padding: "0 5%" }}>
            <List>
            {menuList.map((item, parentIndex) => {
                    return (
                        <Box key={item.id} sx={{padding:collapsed?"5px 0":"1px"}}>
                            {/* Parent Item */}
                            <ListItem
                                button
                                ref={(el) => (menuRefs.current[parentIndex] = el)}
                                component={item.url ? Link : "div"}
                                to={item.url || "#"}
                                sx={{
                                    marginTop: "2%",
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: "8px",
                                    padding: "0px",
                                    borderBottom: "1px solid #2E67BC",
                                    borderLeft: selectedMenu?.parentIndex === parentIndex ? "7px solid #2C1A95" : "none",
                                    background: selectedMenu?.parentIndex === parentIndex ? "aliceblue" : "none",
                                    position: "relative",
                                    cursor: item.disabled ? "not-allowed" : "pointer",
                                    opacity: item.disabled ? 0.5 : 1,
                                    pointerEvents: item.disabled ? "none" : "auto",
                                }}
                                onClick={() => handleMenuClick(parentIndex)}
                            >
                                <ListItem sx={{paddingLeft: collapsed ? "10px":"16px",paddingRight: collapsed ? "10px":"16px"}}>
                                    <Tooltip title={collapsed ? item.text : ''} placement="right">
                                        <ListItemIcon sx={{minWidth:"35px"}}>
                                            <img src={item.icon} alt={item.text} width="24" height="24" /> 
                                        </ListItemIcon>
                                    </Tooltip>
                                    {!collapsed && <ListItemText primary={item.text} />}
                                </ListItem>
                                {item.text == "Lead Generation" && SnapShotStatus != 2 ? <Chip label="Enable" color="primary" size="small" variant="outlined"/> :  (item.text == "Tax Information" && user.roles_id === 3 &&  taxFlag == 2 ? <Chip label="Required"  color="error" size="small" sx={{fontSize:'12px'}}/> : "")}
                                {item.submenu && (openMenuToggle === parentIndex ? <ExpandLess /> : <ExpandMore />)}
                            </ListItem>

                            {/* Submenu Items */}
                            {item.submenu && (
                                <Collapse in={openMenuToggle === parentIndex} timeout="auto" unmountOnExit>
                                    <List sx={{ paddingLeft: "20px" }}>
                                        {item.submenu.map((subItem, childIndex) => {
                                              const refIndex = `${parentIndex}-${childIndex}`;
                                        return(
                                            <ListItem
                                                button
                                                key={subItem.id}
                                                ref={(el) => (menuRefs.current[refIndex] = el)}
                                                component={Link}
                                                to={subItem.url}
                                                onClick={(e) => e.stopPropagation()}
                                                sx={{
                                                    padding: "8px 10px",
                                                    borderRadius: "6px",
                                                    gap: "12px",
                                                    borderBottom: "1px solid #E0E0E0",
                                                    "&:hover": { backgroundColor: "#f0f0f0" },
                                                    borderLeft: selectedMenu?.parentIndex === parentIndex && selectedMenu?.childIndex === childIndex ? "7px solid #2C1A95" : "none",
                                                    background: selectedMenu?.parentIndex === parentIndex && selectedMenu?.childIndex === childIndex ? "aliceblue" : "none",
                                                }}
                                            >
                                                {subItem.icon && (
                                                    <img src={subItem.icon} alt={subItem.text} width="24" height="24" />
                                                )}
                                                <ListItemText primary={subItem.text} />
                                            </ListItem>
                                         )}
                                        )}
                                    </List>
                                </Collapse>
                            )}
                        </Box>
                    )
                }
                )}
            </List>
            </Box>
            </Box>
            </>
    );
    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
      }));
    
    useEffect(() => {
        if (appBarRef.current) {
            let appBarHeight = appBarRef.current.clientHeight;
            // console.log("appBarHeight",appBarHeight);
            localStorage.setItem("appBarHeight", appBarHeight)
        }
    }, []);
    return (
        <div>
            <CssBaseline />
            <Box>
                {/* Header */}
                <AppBar position="fixed" ref={appBarRef}  open={true} sx={{ bgcolor: "white", color: "black", zIndex: theme.zIndex.drawer + 1, boxShadow: "none", borderBottom: "2px solid #3FAC19", paddingRight:isMobile?"2px !important":"2px"}}>
                    <Toolbar  sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", minHeight: "80px !important" }}>
                        {/* Left Side - Logo */}
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img src={require('../assets/images/mainLogo.jpg')} alt="Main Logo" style={{ width: isMobile ? "130px" : "200px" }} height="auto" />
                        </Box>
                        <Box sx={{ flexGrow: 1 }}></Box>
                        {
                            switchedAccount
                             && !isMobile
                                ?
                                <Grid p={1}>                                
                                    {<AffiliateMenu />}
                                </Grid>
                                :
                                <>
                                    {user.roles_id >= 3 ?
                                        <>
                                            {/* Right Side - Other Content */}
                                            
                                                {/* Support Icons */}
                                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "right", textAlign: "right",marginLeft:isMobile?"3% !important;":"58%!important;",marginRight:"7px" }}>
                                                    <Typography sx={{ fontSize: isMobile ? "0.7rem" : "1rem",textAlign:"center" }}>Support Available On</Typography>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", maxWidth: "200px" }}>
                                                        <IconButton color="primary" sx={{ flexGrow: 0,padding:isMobile?"0px":"8px" }}>
                                                            <a href='https://api-wa.co/JrzyQs' target='_blank'><img src={WhatsAppIcon} alt='whatsapp img'  /></a>
                                                        </IconButton>
                                                        <IconButton color="secondary" sx={{ flexGrow: 0,padding:isMobile?"0px":"8px" }}>
                                                            <a href='https://ig.me/m/myfreescorenow' target='_blank'><img src={InstagramIcon} alt='instagram img' /></a>
                                                        </IconButton>
                                                        <IconButton color="primary" sx={{ flexGrow: 0,padding:isMobile?"0px":"8px" }}>
                                                            <a href='https://m.me/myfreescorenow' target='_blank'><img src={facebookMessanger} alt="messenger img" /></a>
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                        </>
                                        : ''}
                                </>
                        }
                        <Box sx={{ display: "flex", alignItems: "center", gap: isMobile?0.5:2 }}>
                            <Grid
                                container
                                id="userwayBtn"
                                tabIndex="0"
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    border: "1px solid #2C1A95",
                                    padding: "4px 8px",
                                    width: isMobile ? "2em" : "8em",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                            >
                                <Stack direction="row" sx={{ gap: 1 }} >
                                    {isMobile ?
                                        <img src={google} alt="google" style={{ width:  "13px" }}/>
                                        : <>
                                            <img src={google} alt="google" />
                                            <Typography sx={{ color: "#2C1A95" }}>English</Typography>
                                        </>
                                    }
                                </Stack>
                            </Grid>
                            <Box
                                display="flex"
                                flexDirection={isMobile? "column" :"row"}
                                alignItems="center"
                                gap={1}
                                >
                            <IconButton
                                size="large"
                                edge="end"
                                aria-label="account of current user"
                                aria-haspopup="true"
                                onClick={handleProfileMenuOpen}
                                // sx={{display:"contents"}}
                            >
                                <StyledBadge overlap="circular" anchorOrigin={{ vertical: "bottom", horizontal: "right" }} variant="dot">
                                    <img src={profile} alt="profile" style={{width:isMobile?"13px":"auto"}} />
                                </StyledBadge>
                                <Typography sx={{fontSize:isMobile? "0.5rem" : "1rem",textAlign:"center"}} >
                                        {
                                            switchedAccount
                                                ?
                                                admin.first_name + " " + admin.last_name
                                                :
                                                user.first_name + " " + user.last_name
                                        }
                                        {/* {user.first_name + " " + user.last_name} */}
                                    </Typography>
                                    </IconButton>
                                    </Box>
                        </Box>
                        {isMobile && (
                            <IconButton edge="right" color="inherit" onClick={handleDrawerToggle}>
                                <MenuIcon />
                            </IconButton>
                        )}
                    </Toolbar>
                    {
                            switchedAccount && isMobile
                                ?
                                <>  
                                <div style={{borderTop: "2px solid #3FAC19",padding:"1%"}}>                              
                                    {<AffiliateMenu />}
                                    </div>
                                </>
                                :""
                    }
                </AppBar>
                {renderMenu}
            </Box>
            {/* Sidebar */}
            <Box className={window.location.pathname === '/affiliate/initialcobrandsetup' ? 'drawerHide' : ''}
                sx={{ marginTop: `${localStorage.getItem("appBarHeight")} px` }}>
                <Drawer
                    variant={isMobile ? "temporary" : "permanent"}
                    open={isMobile ? mobileOpen : true}
                    onClose={handleDrawerToggle}
                    sx={{
                        "& .MuiDrawer-paper": {
                            width: collapsed ? "80px" : drawerWidth,
                            boxSizing: "border-box",
                            top: (isMobile && switchedAccount) ? "125px" : "80px",
                            height: isMobile ? "-webkit-fill-available" : "calc(100vh - 80px)",
                            overflowX: "hidden",
                            transition: "width 0.3s ease",
                        },
                    }}
                >
                    {!isMobile && (user?.roles_id === 1 || user?.roles_id === 2) && (
                        <DrawerHeader sx={{justifyContent:collapsed?"center":"flex-end"}}>
                            {/* {(user?.roles_id === 1 || user.roles_id ===2 )  && ( */}
                                <IconButton onClick={changedCollapsedValue}>
                                {collapsed ? <img src={Collapsible} alt="Collapsible" width="24" height="24"/> : <img src={CollapsibleOpen} width="24" height="24" alt="CollapsibleOpen"/>}
                                </IconButton>
                             {/* )}  */}
                        </DrawerHeader>
                        )}
                    {drawerContent}
                </Drawer>
            </Box>
            {/* Logo Modal Starts */}
            <Dialog
                open={uploadLogo}
                onClose={handleCloseUploadLogo}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <LogoEdit id={companyId} logoEditURL={handleLogoURL} logoFlagEdit={handleLogoFlag} setOpen={handleCloseUploadLogo} source="company" logo={config.BACKEND_URL + "images/companyLogo/" + companyLogoUrl} type={logoType} text={logoText === null || logoText === "null" ? '' : logoText} />
            </Dialog>
            {/* Logo Modal Ends */}
            {/* loader code start */}
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                // onClick={handleFreezStop}
                >
                    <Freez />
                </Backdrop>
            </div>
            {/* loader code end */}
        </div>
    );
};

export default AppSidebar;
